import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-billing-confirmation-popup',
  templateUrl: './billing-confirmation-popup.component.html',
  styleUrls: ['./billing-confirmation-popup.component.scss']
})
export class BillingConfirmationPopupComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<BillingConfirmationPopupComponent>,) { }

  ngOnInit(): void {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}
